import axios, { CancelTokenSource } from 'axios';
import React from 'react';
import dayjs from 'dayjs';
import { CSVLink } from 'react-csv';

import FormSearch from '../../components/forms/formSearch/FormSearch';
import FormSelect from '../../components/forms/formSelect/FormSelect';
import FormNakedSelect from '../../components/forms/formNakedSelect/FormNakedSelect';
import FormOption from '../../components/forms/formOption/FormOption';
import Spinner, { SpinnerSize } from '../../components/shared/spinner/Spinner'
import Arrow from '../../components/shared/arrow/Arrow';

import { upcommingMeetings } from '../../services/tools';

interface IPeriod {
    period: string;
    name: string;
}

interface IMeeting {
    id: string;
    groupId: string;
    subject: string;
    startTime: string;
    endTime: string;
    responsibles: IResponsible[];
}

interface IResponsible {
    diNumber: number;
    role: number;
    fullName: string;
}

interface IOwnState {
    isLoading: boolean;
    cancelToken: CancelTokenSource;
    meetings: IMeeting[];
    groupedMeetings: { [key: string]: IMeeting[] };
    responsibles: IResponsible[];
    periods: IPeriod[];
    period: string;
    responsible?: string;
    searchPhrase: string;
    isSearchInvalid: boolean;
}

const responsibleRoleMap: { [key: string]: string } = {
    'Responsible': 'PA',
    'Coordinator': 'FA'
};

class UpcommingMeetingsIndex extends React.Component<{}, IOwnState> {
    private searchRef = React.createRef<FormSearch>();

    constructor(props: {}) {
        super(props);

        let date = dayjs(),
            periods: IPeriod[] = [];

        for (var i = 0; i < 6; i++) {
            let newDate = date.add(1, 'M');

            periods.push({
                period: `${date.format('YYYY-MM-DD')};${newDate.subtract(1, 'd').format('YYYY-MM-DD')}`,
                name: `${date.format('DD.MM.YY')}-${newDate.subtract(1, 'd').format('DD.MM.YY')}`
            })

            date = newDate;
        }

        this.state = {
            isLoading: true,
            cancelToken: axios.CancelToken.source(),
            meetings: [],
            groupedMeetings: {},
            responsibles: [],
            periods: periods,
            period: periods[0].period,
            responsible: undefined,
            searchPhrase: '',
            isSearchInvalid: false
        };
    }

    public async componentDidMount() {
        await this.fetchUpcommingMeetings();
    }

    public componentWillUnmount() {
        this.state.cancelToken.cancel();
    }

    public render() {
        const groupedMeetingKeys = this.state.groupedMeetings ? Object.keys(this.state.groupedMeetings) : [];

        return <React.Fragment>
            <section className="section">
                <div className="deck">
                    <div className="w--md banner-title">
                        <h1>Kommende møder</h1>
                    </div>
                </div>
                <div className="deck">
                    <div className="event-calendar">
                        <div className="w--md form">
                            <div className="form__section form__section--horizontal event-calendar__filters">
                                <div className="flex-grid flex-grid--top-margin form__section__inner">
                                    <div className="flex-grid__col flex-grid__col--12 flex-grid__col--sm-3 flex-grid__col--md-2">
                                        <FormNakedSelect name="period" value={this.state.period.toString()} onChange={this.handlePeriodChange}>
                                            <FormOption value="">Vis alle kommende</FormOption>
                                            {this.state.periods.map((period, index) => {
                                                return <FormOption key={`period${index}`} value={period.period.toString()}>{period.name}</FormOption>;
                                            })}
                                        </FormNakedSelect>
                                    </div>
                                    <div className="flex-grid__col flex-grid__col--12 flex-grid__col--sm-9 flex-grid__col--md-10">
                                        <div className="flex-grid">
                                            <div className="flex-grid__col flex-grid__col--sm-6">
                                                <form onSubmit={this.handleSubmitSearch}>
                                                    <FormSearch name="search" placeholder="Søg her..." initialValue={''} invalid={this.state.isSearchInvalid} notice={this.state.isSearchInvalid ? 'Udfyldes med min. 3 tegn' : ''} ref={this.searchRef} onChange={this.handleSearchChange} />
                                                </form>
                                            </div>
                                            <div className="flex-grid__col flex-grid__col--sm-6">
                                                <FormSelect name="responsible" value={this.state.responsible} onChange={this.handleResponsibleRoleChange}>
                                                    <FormOption value="">Vis alle</FormOption>
                                                    {this.state.responsibles.sort((a, b) => (a.fullName > b.fullName) ? 1 : -1).map((responsible, index: number) => {
                                                        return <FormOption key={`responsible${index}`} value={responsible.diNumber.toString()}>{responsible.fullName}</FormOption>;
                                                    })}
                                                </FormSelect>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {this.state.isLoading &&
                                <Spinner size={SpinnerSize.Large} />
                            }
                            {!this.state.isLoading && groupedMeetingKeys.length === 0 &&
                                <div className="flex-grid">
                                    <div className="flex-grid__col flex-grid__col--12 align-center--text">
                                        Ingen møder
                                    </div>
                                </div>
                            }
                            {!this.state.isLoading && groupedMeetingKeys.length > 0 &&
                                groupedMeetingKeys.map((key: string, groupIndex: number) => {
                                    const meetingGroup = this.state.groupedMeetings[key],
                                        date = dayjs(key),
                                        day = date.format('ddd').replace('.', '');

                                    return <div key={`group${groupIndex}`} className="flex-grid event-calendar__row">
                                        <div className="flex-grid__col flex-grid__col--sm-2 event-calendar__date">
                                            <p>
                                                <span className="bodytext-lg">{day.charAt(0).toUpperCase() + day.slice(1)}<span className="v--desktop-only">dag</span></span><br />
                                                <span className="bodytext-sm">{date.format('DD.MM')}</span>
                                            </p>
                                        </div>
                                        <div className="flex-grid__col flex-grid__col--sm-10 event-calendar__list">
                                            <ul className="abstract-list">
                                                {meetingGroup.map((meeting, meetingIndex: number) => {
                                                    return <li key={`meeting-${groupIndex}-${meetingIndex}`} className="abstract-list__item abstract-list__item--persistent-arrow abstract-list__item--no-image">
                                                        <div className="abstract-list__item__content">
                                                            <p className="meta">{dayjs(meeting.startTime).format('HH:mm')}</p>
                                                            <a className="button" href={`/Group/${meeting.groupId}/Meeting/${meeting.id}`}>
                                                                <h4 className="abstract-list__item__content__head">
                                                                    {meeting.subject}
                                                                </h4>
                                                            </a>
                                                            {meeting.responsibles &&
                                                                <div className="tags tags--always-visible">
                                                                    <ul className="tags__list">
                                                                        {meeting.responsibles.map((responsible, responsibleIndex: number) => {
                                                                            return <li key={`responsible-${groupIndex}-${responsibleIndex}`} className="tags__list__item"><div className="button button--tag button--tag--inactive">({responsibleRoleMap[responsible.role]}) {responsible.fullName}</div></li>;
                                                                        })}
                                                                    </ul>
                                                                </div>
                                                            }
                                                        </div>
                                                        <a className="button arrow__wrapper" href={`/Group/${meeting.groupId}/Meeting/${meeting.id}`}>
                                                            <Arrow modifierClass="arrow--colored" />
                                                        </a>
                                                    </li>;
                                                })}
                                            </ul>
                                        </div>
                                    </div>;
                                })
                            }
                        </div>
                    </div>
                </div>
                {!this.state.isLoading && groupedMeetingKeys.length > 0 &&
                    <div className="deck">
                        <div className="w--md">
                            <CSVLink className="button button--primary button--small" data={this.getCsvData()} separator=";" filename={"kommende-moeder.csv"}>
                                <span className="text">Export til Excel</span>
                            </CSVLink>
                        </div>
                    </div>
                }
            </section>
        </React.Fragment>;
    }

    private fetchUpcommingMeetings = async () => {
        this.setState({
            isLoading: true
        });

        var meetings: IMeeting[] = [];

        try {
            const dateParts = this.state.period ? this.state.period.split(';') : undefined,
                startDate = dateParts ? dateParts[0] : undefined,
                endDate = dateParts ? dateParts[1] : undefined;

            meetings = await upcommingMeetings({ startDate: startDate, endDate: endDate, searchPhrase: this.state.searchPhrase }, this.state.cancelToken);
        } catch (e) {
            console.log(e);
        }

        const responsibles = meetings && meetings.length > 0 ? meetings.map(m => m.responsibles).reduce((prev, curr) => prev.concat(curr)).filter((element, index, array) => array.map(responsible => responsible.diNumber).indexOf(element.diNumber) === index) : [],
            responsible = responsibles.find(responsible => responsible.diNumber.toString() === this.state.responsible) ? this.state.responsible : '';

        this.setState({
            meetings: meetings,
            responsibles: responsibles,
            responsible: responsible,
            isLoading: false
        }, () => this.filterMeetings());
    }

    private filterMeetings = () => {
        var meetings = this.state.meetings;

        meetings = this.state.responsible ? meetings.filter(meeting => meeting.responsibles.filter(responsible => responsible.diNumber.toString() === this.state.responsible).length > 0) : meetings;
        meetings = this.state.searchPhrase !== '' ? meetings.filter(meeting => meeting.subject.toLowerCase().indexOf(this.state.searchPhrase) > -1) : meetings;

        var groupedMeetings = this.groupMeetingsByDate(meetings);

        this.setState({
            groupedMeetings: groupedMeetings
        });
    }

    private groupMeetingsByDate = (array: IMeeting[]) => {
        return array.reduce(function (storage, item) {
            var group = item['startTime'].split('T')[0];

            storage[group] = storage[group] || [];
            storage[group].push(item);

            return storage;
        }, {} as { [key: string]: IMeeting[] });
    }

    private handlePeriodChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedPeriod = e.target.value,
            isSearchPhraseInvalid = this.IsSearchPhraseInvalid(selectedPeriod, this.state.searchPhrase);

        this.setState({
            period: selectedPeriod,
            isSearchInvalid: isSearchPhraseInvalid
        }, async () => !isSearchPhraseInvalid ? await this.fetchUpcommingMeetings() : {});
    }

    private handleResponsibleRoleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedResponsible = e.target.value;

        this.setState({
            responsible: selectedResponsible
        }, () => this.filterMeetings());
    }

    private handleSearchChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const searchPhrase = this.searchRef.current!.value() || '';

        this.setState({
            searchPhrase: searchPhrase,
            isSearchInvalid: this.IsSearchPhraseInvalid(this.state.period, searchPhrase)
        });
    }

    private handleSubmitSearch = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const searchPhrase = this.searchRef.current!.value() || '';

        this.setState({
            searchPhrase: searchPhrase
        }, async () => !this.state.isSearchInvalid ? await this.fetchUpcommingMeetings() : {});
    }

    private IsSearchPhraseInvalid(period: string, searchPhrase: string) {
        return period === '' && searchPhrase.trim().length < 3;
    }

    private getCsvData = () => {
        return this.state.meetings.map(meeting => {
            let mainData: { [key: string]: any } = {
                'Gruppe ID': meeting.groupId,
                'Mødetitel': this.sanitizeCsvStrings(meeting.subject),
                Start: dayjs(meeting.startTime).format('YYYY-MM-DD HH:mm'),
                Slut: dayjs(meeting.endTime).format('YYYY-MM-DD HH:mm'),
            };

            meeting.responsibles.forEach((responsible, index) => {
                mainData[`Ansvarlig${index + 1}`] = responsible.fullName;
            });

            return mainData;
        });
    }

    private sanitizeCsvStrings = (string: string) => {
        return string.replace(/"/g, '""');
    }
}

export default UpcommingMeetingsIndex;